/**
 * MODULE: domain/sales-target-management/frontend/hooks/useMyTerritoryOptions
 * PURPOSE: Territory pickers for sales targets — uses caller assignments
 */

import { useQuery } from '@tanstack/react-query';
import { apiV1Url, getAuthHeaders } from '@shared/lib/frontend/api/config';
import { fetchWith429Retry } from '@shared/lib/frontend/api/errors';

export type SalesTargetTerritoryOption = {
  id: string;
  name: string;
  territory_code?: string;
};

export function useMyTerritoryOptions() {
  return useQuery({
    queryKey: ['territories', 'my-territories', 'sales-targets'],
    queryFn: async (): Promise<SalesTargetTerritoryOption[]> => {
      const res = await fetchWith429Retry(apiV1Url('/territories/my-territories'), {
        headers: getAuthHeaders(),
      });
      if (!res.ok) return [];
      const data = (await res.json()) as { territories?: SalesTargetTerritoryOption[] };
      return data.territories ?? [];
    },
    staleTime: 120_000,
    refetchOnWindowFocus: false,
  });
}
